const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVekt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 449.146 205.885 C 449.146 294.272 396.719 347.137 341.961 402.219 C 308.867 434.38 276.967 467.685 245.01 500.989 C 213.111 467.685 181.154 434.38 148.06 402.219 C 93.359 347.137 40.022 294.272 40.022 205.885 C 40.022 178.927 45.322 152.23 55.608 127.324 C 65.894 102.419 80.974 79.787 99.983 60.727 C 118.992 41.661 141.555 26.542 166.393 16.227 C 191.23 5.906 217.847 0.601 244.726 0.601 C 271.611 0.601 298.228 5.906 323.065 16.227 C 347.903 26.542 370.466 41.661 389.475 60.727 C 408.484 79.787 423.564 102.419 433.85 127.324 C 444.136 152.23 449.43 178.927 449.43 205.885 L 449.146 205.885 Z",
    fill: "white",
    style: {},
    transform: "matrix(0.9999999999999999, 0, 0, 1, -1.1368683772161603e-13, 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.827345013618469, 0, 0, -1.8063569068908691, 36.47797852575445, 411.2542201413936)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2271.23,1135.07 c 0,624.97 -511.2,1136.16 -1136.16,1136.16 C 512.27,2271.23 1.07422,1760.04 1.07422,1135.07 1.07422,512.281 512.27,1.07031 1135.07,1.07031 c 624.96,0 1136.16,511.21069 1136.16,1133.99969",
    style: {
      fill: "#f14824",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2271.23,1135.07 c 0,624.97 -511.2,1136.16 -1136.16,1136.16 C 512.27,2271.23 1.07422,1760.04 1.07422,1135.07 1.07422,512.281 512.27,1.07031 1135.07,1.07031 c 624.96,0 1136.16,511.21069 1136.16,1133.99969 z",
    style: {
      fill: "none",
      stroke: "#f14824",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1986.83,1135.07 c 0,468.72 -383.04,851.77 -851.76,851.77 -466.558,0 -849.597,-383.05 -849.597,-851.77 0,-466.55 383.039,-849.601 849.597,-849.601 468.72,0 851.76,383.051 851.76,849.601",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1986.83,1135.07 c 0,468.72 -383.04,851.77 -851.76,851.77 -466.558,0 -849.597,-383.05 -849.597,-851.77 0,-466.55 383.039,-849.601 849.597,-849.601 468.72,0 851.76,383.051 851.76,849.601 z",
    style: {
      fill: "none",
      stroke: "#f14824",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1663.55,608.762 V 802.43 c 0,54.011 -43.2,99.359 -100.08,99.359 v 0 c -25.2,0 -51.12,-8.641 -70.56,-25.918 v 17.277 h -59.76 V 608.762 h 59.76 V 790.91 c 0,74.16 110.88,74.16 110.88,0 V 608.762 h 59.76",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1663.55,608.762 V 802.43 c 0,54.011 -43.2,99.359 -100.08,99.359 v 0 c -25.2,0 -51.12,-8.641 -70.56,-25.918 v 17.277 h -59.76 V 608.762 h 59.76 V 790.91 c 0,74.16 110.88,74.16 110.88,0 V 608.762 Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1342.43,608.762 V 802.43 c 0,54.011 -43.2,99.359 -97.2,99.359 h -2.88 c -25.2,0 -51.12,-8.641 -70.56,-25.918 v 17.277 h -59.76 V 608.762 h 59.76 V 790.91 c 0,74.16 110.88,74.16 110.88,0 V 608.762 h 59.76",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1342.43,608.762 V 802.43 c 0,54.011 -43.2,99.359 -97.2,99.359 h -2.88 c -25.2,0 -51.12,-8.641 -70.56,-25.918 v 17.277 h -59.76 V 608.762 h 59.76 V 790.91 c 0,74.16 110.88,74.16 110.88,0 V 608.762 Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 793.793,808.191 c -5.762,-17.281 -5.762,-37.441 -5.762,-56.882 0,-20.161 0,-39.598 5.762,-56.879 14.398,-54 62.637,-93.59 116.637,-93.59 56.883,0 105.12,39.59 116.64,93.59 5.04,17.281 7.92,36.718 7.92,56.879 0,19.441 -2.88,39.601 -7.92,56.882 -11.52,54 -59.757,93.598 -116.64,93.598 -54,0 -102.239,-39.598 -116.637,-93.598",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 793.793,808.191 c -5.762,-17.281 -5.762,-37.441 -5.762,-56.882 0,-20.161 0,-39.598 5.762,-56.879 14.398,-54 62.637,-93.59 116.637,-93.59 56.883,0 105.12,39.59 116.64,93.59 5.04,17.281 7.92,36.718 7.92,56.879 0,19.441 -2.88,39.601 -7.92,56.882 -11.52,54 -59.757,93.598 -116.64,93.598 -54,0 -102.239,-39.598 -116.637,-93.598 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 853.551,802.43 c -5.758,-17.27 -5.758,-34.551 -5.758,-51.121 0,-17.278 0,-34.559 5.758,-51.11 8.64,-25.929 30.961,-42.48 56.879,-42.48 25.215,0 51.125,16.551 56.883,42.48 5.757,16.551 8.64,33.832 8.64,51.11 0,16.57 -2.883,33.851 -8.64,51.121 -5.758,25.211 -31.668,42.48 -56.883,42.48 -25.918,0 -48.239,-17.269 -56.879,-42.48",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 853.551,802.43 c -5.758,-17.27 -5.758,-34.551 -5.758,-51.121 0,-17.278 0,-34.559 5.758,-51.11 8.64,-25.929 30.961,-42.48 56.879,-42.48 25.215,0 51.125,16.551 56.883,42.48 5.757,16.551 8.64,33.832 8.64,51.11 0,16.57 -2.883,33.851 -8.64,51.121 -5.758,25.211 -31.668,42.48 -56.883,42.48 -25.918,0 -48.239,-17.269 -56.879,-42.48 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 662.754,893.148 h 71.277 V 836.27 H 662.754 V 680.031 c 0,-11.511 11.519,-22.312 25.918,-22.312 v 0 c 8.641,0 20.16,0 28.082,2.883 l 17.277,-51.84 c -14.398,-5.043 -30.961,-7.922 -45.359,-7.922 -48.242,0 -84.961,36.711 -84.961,84.961 V 836.27 h -40.316 v 56.878 h 40.316 v 62.653 l 59.043,51.109 V 893.148",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 662.754,893.148 h 71.277 V 836.27 H 662.754 V 680.031 c 0,-11.511 11.519,-22.312 25.918,-22.312 v 0 c 8.641,0 20.16,0 28.082,2.883 l 17.277,-51.84 c -14.398,-5.043 -30.961,-7.922 -45.359,-7.922 -48.242,0 -84.961,36.711 -84.961,84.961 V 836.27 h -40.316 v 56.878 h 40.316 v 62.653 l 59.043,51.109 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28,
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    transform: "matrix(25.465132, 0.196748, 0.194517, -25.764685, 1132.156152, 1351.694365)"
  }, "X"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVekt);
export default __webpack_public_path__ + "static/media/vekt.78b5b85b1bdc706457647a7dc054fa1f.svg";
export { ForwardRef as ReactComponent };